{
  "titles": {
    "bookTransfer": "Betaling verwerken",
    "confirmRepayment": "Weet je het zeker?"
  },
  "fields": {
    "labels": {
      "amount": "Bedrag",
      "counterpartName": "Naam rekeninghouder",
      "counterpartIban": "IBAN rekeninghouder",
      "reference": "Referentie",
      "description": "Omschrijving",
      "depositDate": "Datum storting",
      "loan": "Lening",
      "surplusAmount": "Overschot (terugbetaling)"
    },
    "hints": {},
    "validationErrors": {
      "depositDate": {
        "maxDate": "{0} mag niet in de toekomst liggen",
        "nonBookableLoans": "Op deze stortingsdatum kan niet elke lening geboekt worden"
      },
      "amount": {
        "max": "{0} mag niet groter zijn dan {1} voor deze stortingsdatum",
        "matchingTransaction": "Er is geen onverwerkte banktransactie met dit bedrag gevonden op {1}"
      }
    }
  },
  "errors": {
    "validation": {}
  },
  "messages": {
    "renewalRequestConfirmation": "De betaling van de financieringskosten en administratiekosten zijn voldaan. De incasso’s worden geannuleerd. De lening wordt ingelost met een nieuwe lening. De nieuwe lening start automatisch één dag nadat de looptijd van de huidige lening ten einde is gekomen. De huidige lening wordt afgesloten nadat de looptijd voorbij is.",
    "emptyStateDescription": "De incasso's worden aangemaakt. Zodra dit succesvol is, zullen ze hier worden getoond.",
    "financeReceiverRepaymentAllocation": "Leningen worden afgelost op volgorde van incassodatum (oudste eerst). Per lening worden eerst administratiekosten en boeterente verrekend, daarna de lening zelf.",
    "surplusConfirmation": "Het bedrag is hoger dan er openstaat. Hieronder zie je hoe de aflossing wordt verdeeld. Het overschot wordt als taak klaargezet om terug te betalen aan de klant."
  },
  "actions": {
    "addTransfer": "Betaling toevoegen",
    "revalidateDirectDebits": "Betaling opnieuw controleren",
    "confirmRepayment": "Bevestigen en inboeken",
    "back": "Terug"
  },
  "type": {
    "DirectDebit": "Incasso",
    "Transfer": "Overboeking",
    "Renewal": "Afgelost met"
  },
  "status": {
    "Scheduled": "Ingepland",
    "Successful": "Betaald",
    "Failed": "Mislukt",
    "Cancelled": "Geannuleerd",
    "Processing": "Betaling in behandeling"
  },
  "specification": {
    "openAmount": "Openstaand bedrag",
    "administrationCosts": "Administratiekosten",
    "penaltyAmount": "Achterstallige rente",
    "renewedInterestAmountIncrease": "Verschil tarief"
  }
}
